import { Box, Link, Stack, Typography } from '@mui/material';
import dpsLogo from '/@/components/bag-quality/dps/assets/DPS.svg?url';
import dekalbLogo from '/@/components/bag-quality/dps/assets/dekalb_arg.png?url';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const libraryUrl = (slug: string) => reverse('library.LibraryDetail', { params: { slug } });

const DpsBanner = () => {
    return (
        <Box>
            <Box
                sx={{
                    background: 'linear-gradient(170deg, #006f9b 1%, #10384f 100%)',
                    px: 2,
                    py: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Box component='img' src={dpsLogo} alt='DPS' sx={{ height: 36 }} />
                <Box component='img' src={dekalbLogo} alt='Dekalb' sx={{ height: 51 }} />
            </Box>
            <Stack spacing={2} sx={{ backgroundColor: '#e7f8ff', p: 2 }}>
                <Typography variant='h5' color='primary' fontWeight='bold'>
                    {_('Beneficios del programa DPS')}
                </Typography>
                <Typography variant='body1' color='primary'>
                    {_(
                        'DEKALB cuenta con el programa DPS que te permite ofrecerle al productor un análisis de poder germinativo y hacer prueba de placas en cualquier distribuidor Bayer.'
                    )}
                </Typography>
                <Typography variant='body1' color='primary'>
                    {_('Para más información, accedé a los manuales DPS de ')}
                    <Link
                        href={libraryUrl('dps-probador-placa')}
                        target='_blank'
                        rel='noopener'
                        underline='always'
                        color='secondary'
                    >
                        {_('probador de Placa')}
                    </Link>
                    {_(' o ')}
                    <Link
                        href={libraryUrl('germinity-power')}
                        target='_blank'
                        rel='noopener'
                        underline='always'
                        color='secondary'
                    >
                        {_('poder germinativo')}
                    </Link>
                    {_(', o bien consultá con tu distribuidor de confianza.')}
                </Typography>
            </Stack>
        </Box>
    );
};

export default DpsBanner;
